import $axios from 'axios'
import Router from '@/router'
import { Message } from 'element-ui'
import { getCookies,setStore,setCookies } from "@/utils/utils";
import baseUrl from "@/fetch/url";
/*
 * @发送网络请求  sendRequest()
 * @param {string}   url  请求的地址
 * @param {object}   data:object    要发送的参数
 *                   method:string  请求方式 GET或POST
 *                   param:array    扩展参数
 * @return {object}  res  后台返回数据
 */

const sendRequest = (  url,{ data = {}, method = 'POST',chatToken = '', isWarning = true, timeout = 30000, showError = false, errorMsg = '', ...param } = {} ) => {
  return new Promise((resolve, reject) => {

    let instance = $axios.create({
      baseURL: url,
      method: method,
      timeout: timeout, // 超时时间（默认30s，可按接口单独传入，如交卷接口 15s）
      withCredentials: false, //表示跨域请求时是否需要使用凭证
      headers: {
        // 'Content-Type':'application/x-www-form-urlencoded',
         Authorization: chatToken || getCookies("token") || ""
        },
    })

    // 添加请求拦截器
    instance.interceptors.request.use(
      config => {

        // 生成签名
        let wuBaNfJson = {
          params: data,
          timestamp: new Date().getTime(),
          // sign: sign(data)
        }

        // config.method === 'post'
        //   ? (config.data = wuBaNfJson)
        //   : (config.params = wuBaNfJson)

        if(config.method === 'post' || config.method === 'delete'){
          config.data = data
        }else{
          config.params = data
        }
        return config

      },

      error => {
        return Promise.reject(error)
      }
    )

    // 添加响应拦截器
    instance.interceptors.response.use(
      response => {
        if (response.data.code !== 200) {
          if (response.data.code === 401 || response.data.code === 418 || response.data.code === 416 || response.code === 416) {
            setCookies("token", "");
            setCookies("userInfo", "");
            setCookies("onOff", "");
            setCookies("homeWorkParams", "");
            Router.push({ name: "loginout" });
          }
          if (isWarning) {
            if (response.data.code !== 601) {
              Message({
                message: response.data.msg,
                type: "warning",
                duration: 3000
              });
            }
          }
        }
        return response.data;
      },

      error => {
        return Promise.reject(error)
      }
    )

    instance()
      .then(response => {

        response && resolve(response)

      })
      .catch(error => {
        console.log('请求异常信息：' + error,error.response);
        // 按需提示：超时或网络报错时给出错误提示（仅对开启 showError 的接口生效，其它接口不变）
        if (showError) {
          const isTimeout = error && (error.code === 'ECONNABORTED' || /timeout/i.test(error.message || ''));
          Message.error(errorMsg || (isTimeout ? '请求超时，请稍后重试' : '网络异常，请稍后重试'));
        }
        reject(error)
      })
  })
}

export default sendRequest



// WEBPACK FOOTER //
// ./src/fetch/fetch.js